import { useEffect, useContext } from 'react';
import icon_arrow_left from "../../../assets/images/icon_arrow_left.svg";
import { ContextState } from "../../../layout";
import { useLocation } from 'react-router-dom';


const Pagination = ({ search, flag, setFlag, dataSource, pageData, setPageData, handlePage, setDataSource, filteredPosts, totalDta,selectedPage}) => {
    let count = 0;
    let hidePage = 0;
    let pageDataCopy = { ...pageData }
    const newpageData = totalDta
    const { contextReducer } = useContext(ContextState);
    const location = useLocation();
    const { pathname  } = location;


    // useEffect(() => {
    //     if ((dataSource || totalDta) && (newpageData ||  dataSource.length > 0)) {
    //         const totalData =  newpageData ? newpageData :dataSource.length ;
    //         let fixCurrent = pageData.currentPage;
    //         const totalPage = [];
    //         for (let i = 1; i <= Math.ceil(totalData / pageData.perPage); i++) {
    //             totalPage.push(i);
    //         }


    //         let len = pageData.totalPage.length;
    //         let count = 1;
    //         do {
    //             len--;
    //             count++;
    //             fixCurrent = pageData.currentPage - count;
    //             if (fixCurrent <= 0) fixCurrent = 1;
    //         } while (pageData.perPage * len - pageData.perPage + 1 > totalData)

    //         /** New logic for handling filters  */

    //         /*if (pageData.perPage * t - pageData.perPage + 1 > totalData) {
    //             fixCurrent = pageData.currentPage - 1;
    //             if (fixCurrent <= 0) fixCurrent = 1;
    //         }*/

    //         /** due to pin unpin pagination issue this code commented  */
    //         /*else {
    //           fixCurrent = 1;
    //         }*/

    //         const indexOfLastPage = fixCurrent * pageData.perPage;
    //         const indexOfFirstPage = indexOfLastPage - pageData.perPage;
    //         const currentData = dataSource.slice(indexOfFirstPage, indexOfLastPage);
    //         // setPageData({ ...pageData, totalData, totalPage: totalPage, currentPage: fixCurrent })
    //         setPageData({ ...pageData, totalData, totalPage: totalPage, currentPage: 1 })
    //         pageDataCopy.totalData = totalData;
    //         pageDataCopy.totalPage = totalPage;
    //         pageDataCopy.currentPage = fixCurrent;
    //         setDataSource(currentData);
    //     }
    // }, [dataSource, flag ,newpageData]);

    useEffect(() => {
        const totalData = newpageData ? newpageData : dataSource.length;
        if ((dataSource || totalData) && (newpageData || (dataSource?.length ?? 0) > 0)) {
            
            let fixCurrent = pageData.currentPage;
    const totalPage = Array.from({ length: Math.ceil(totalData / pageData.perPage) }, (_, i) => i + 1);

 
    if (fixCurrent > totalPage.length) {
        fixCurrent = totalPage.length;
    }

    fixCurrent = Math.max(fixCurrent, 1);
    
            const indexOfLastPage = fixCurrent * pageData.perPage;
            const indexOfFirstPage = indexOfLastPage - pageData.perPage;
            const currentData = dataSource.slice(indexOfFirstPage, indexOfLastPage);
    
            setPageData(prev => ({
                ...prev,
                totalData,
                totalPage,
                currentPage: fixCurrent
            }));
    
            setDataSource(currentData);
        }
    }, [dataSource, flag, newpageData]); 
    
    useEffect(() => {
        if (dataSource || totalDta && dataSource.length || totalDta > 0) {
            pageDataCopy.currentPage = 1;
            setPageData({ ...pageDataCopy })
            if (setFlag)
                setFlag(!flag)
        }
    }, [search]);


    if (pageData.maxLength <= pageData.currentPage && pageData.currentPage !== pageData.totalPage?.length) {
        hidePage = pageData.currentPage - pageData.maxLength + 1;
    } else {
        hidePage = pageData.currentPage - pageData.maxLength;
    }
    if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'pre-college' || contextReducer.cms_type  === 'certificates' || contextReducer.cms_type  === 'dl-program') && (pathname === "/users" || pathname === "/applicants")){
        if (selectedPage.maxLength <= selectedPage.currentPage && selectedPage.currentPage !== selectedPage.totalPage?.length) {
            hidePage = selectedPage.currentPage - selectedPage.maxLength + 1;
        } else {
            hidePage = selectedPage.currentPage - selectedPage.maxLength;
        }
    }
   

    return (
        <div className="pagination">
            {dataSource && pageData.perPage < dataSource?.length &&
                <ul className="list_unstyled">
                    <li><span onClick={() => { handlePage(pageData.currentPage - 1) }} className={pageData.currentPage !== 1 ? "arrow_previous" : "arrow_previous disabled"}><img src={icon_arrow_left} alt="Arrow previous" height="16" /></span></li>
                    {
                        pageData.totalData && pageData.totalPage.map((page) => {
                            if (page > hidePage && pageData.maxLength !== count) {
                                count++;
                                return (
                                    <li><span className={`${pageData.currentPage === page ? "active" : ""}`} onClick={() => { handlePage(page) }}>{page}</span></li>
                                )
                            }
                        })
                    }
                    <li><span onClick={() => { handlePage(pageData.currentPage + 1) }} className={(pageData.currentPage < pageData.totalPage.length) ? "arrow_next" : "arrow_next disabled"}><img src={icon_arrow_left} alt="Arrow next" height="16" /></span></li>
                </ul>
            }
            {dataSource && pageData.perPage < dataSource?.length || totalDta > 10  &&
                <ul className="list_unstyled">
                    <li><span onClick={() => { handlePage(selectedPage.currentPage - 1) }} className={selectedPage.currentPage !== 1 ? "arrow_previous" : "arrow_previous disabled"}><img src={icon_arrow_left} alt="Arrow previous" height="16" /></span></li>
                    {
                        pageData.totalData && pageData.totalPage.map((page) => {
                            if (page > hidePage && pageData.maxLength !== count) {
                                count++;
                                return (
                                    <li><span className={`${selectedPage.currentPage === page ? "active" : ""}`} onClick={() => { handlePage(page) }}>{page}</span></li>
                                )
                            }
                        })
                    }
                    <li><span onClick={() => { handlePage(selectedPage.currentPage + 1) }} className={(selectedPage.currentPage < pageData.totalPage.length) ? "arrow_next" : "arrow_next disabled"}><img src={icon_arrow_left} alt="Arrow next" height="16" /></span></li>
                </ul>
            }
        </div>
    )
};

export default Pagination